import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";

import "./Header.scss";

const Header = (props) => {
  const { state, dispatch } = useContext(ContextOne);
  const { loggedIn, user } = state;

  const [organizations, setOrganizations] = useState(null);

  const navigate = useNavigate();

  const fetchOrganizations = async () => {
    const data = await ApiService.getOrganizations();
    setOrganizations(data);
  };

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    await fetchOrganizations();

    dispatch({ type: "loading", val: false });
  };

  const handleLogout = (event) => {
    AuthService.logout();
    dispatch({ type: "loggedIn", val: false });
    dispatch({ type: "user", val: false });
    navigate("/login");
  };

  // const setOrganization = (event) => {
  //   dispatch({ type: "loggedIn", val: false });
  //   dispatch({ type: "user", val: false });
  //   dispatch({ type: "organization", val: false });
  //   navigate("/login");
  // };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="header-component">

      <Navbar expand="lg">
        <Navbar.Brand>
          <Link to="/" className="company-name">
            {/* <img height="75px" alt="Pure" src={process.env.PUBLIC_URL + "/img/pure-logo-header.png"} /> */}
            PURE AI
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler"/>

        <Navbar.Collapse id="basic-navbar-nav">
          {
           loggedIn &&
            <Nav className="me-auto">
              <NavDropdown title="Select Organization" id="nav-dropdown-organization">
                { 
                  organizations &&
                  organizations.map(o =>
                    <NavDropdown.Item
                      eventKey="1.1"
                      as={Link}
                      to={o.name}
                      >
                     {o.name}
                    </NavDropdown.Item>
                  )
                }
              </NavDropdown>
            </Nav>
          }

          <Nav className="ms-auto">
            { loggedIn &&
              <div className="nav-link" role="button">
                <Link to="/projects">projects</Link>
              </div>
            }
            { loggedIn &&
              <div className="nav-link" role="button">
                <Link to="/ai-models">models</Link>
              </div>
            }
            { loggedIn &&
              <div className="nav-link" role="button">
                <Link to="/organizations">organizations</Link>
              </div>
            }

            { loggedIn && user.is_admin &&
              <div className="nav-link" role="button">
                <Link to="/users">users</Link>
              </div>
            }

            <div className="nav-link" role="button">
              <Link to="/about">about</Link>
            </div>
            { !loggedIn &&
              <div className="nav-link" role="button">
                <Link to="/login">login</Link>
              </div>
            }
            { loggedIn &&
              <NavDropdown
                title={
                  <FontAwesomeIcon icon={faUser} />
                }
                id="nav-dropdown-user"
                >
                <NavDropdown.Item
                  eventKey="4.1"
                  as={Link}
                  to="/user-profile"
                  >
                  User Profile
                </NavDropdown.Item>
                <NavDropdown.Item
                  eventKey="4.2"
                  onClick={handleLogout}
                  >
                  Sign Out
                </NavDropdown.Item>
              </NavDropdown>
            }
        </Nav>
        </Navbar.Collapse>
      </Navbar>

    </div>
  );
};

export default Header;
